import {ChangeDetectorRef, Component, Input, NgZone, OnInit, ViewChild} from '@angular/core';
import {EventsService} from '../../events/events.service';
import {AuthenticationService} from '../../../authentication.service';
import {SeasonsService} from '../seasons.service';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {MatPaginator} from '@angular/material/paginator';
import {GlobalService} from '../../../global.service';
import {DataSource} from '@angular/cdk/collections';
import {RaceDetailModalComponent} from '../../events/race-detail-modal/race-detail-modal.component';
import {MatDialog, MatTable, MatTableDataSource} from '@angular/material';
import {ReportIncidentComponent} from '../../users/report-incident/report-incident.component';

@Component({
  selector: 'elastic-my-sessions',
  templateUrl: './my-sessions.component.html',
  styleUrls: ['./my-sessions.component.scss']
})
export class MySessionsComponent implements OnInit {

  @Input() event: any;

  @ViewChild(MatTable, {static: true}) table2: MatTable<any>;

  upcomingSessions: any = [];
  pastSessions: MatTableDataSource<any>;
  weekPoints: any = [];
  dataSource: any;
  displayedColumns = ['session_start', 'track', 'server', 'action'];
  displayedColumns2 = ['session_start', 'track', 's_pos', 'f_pos', 'sof', 'rating', 'incidents', 'sr' , 'points', 'action'];

  //@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(private _eventsService: EventsService,
              private _ngZone: NgZone,
              private cdr: ChangeDetectorRef,
              private auth: AuthenticationService,
              private seasonsService: SeasonsService,
              private globalService: GlobalService,
              private dialog: MatDialog,
              private eventsService: EventsService) {

    this.pastSessions = new MatTableDataSource<any>();

  }

  ngOnInit() {

    this.getData();

  }

  getData() {

    this.seasonsService.getMyUpcomingSessions(this.event.event_id).subscribe(
      ( response: HttpEvent<any> ) => {
        switch (response.type) {
          case HttpEventType.Response:
            this.upcomingSessions = response.body;
            this.upcomingSessions.upcoming.forEach((item, index) => {
              //item.signupCloseDate = new Date(item.signupCloses.replace(' ','T') + '+0100');
              item.serverOpenDate = new Date(item.race_date.replace(' ','T') + '+0100');
              item.signedUp = true;
            });
            this.cdr.detectChanges();
            break;
        }
      });

    this.seasonsService.getMySeasonWeekPoints(this.event.event_id).subscribe(
      ( response: HttpEvent<any> ) => {
        switch (response.type) {
          case HttpEventType.Response:
            this.weekPoints = response.body;
            this.cdr.detectChanges();
            break;
        }
      });


    this.seasonsService.getMyPastSessions(this.event.event_id, 0, 5).subscribe(
      ( response: HttpEvent<any> ) => {
        switch (response.type) {
          case HttpEventType.Response:
            this.pastSessions.data = response.body;
            this.pastSessions.data.forEach((item, index) => {
              //item.signupCloseDate = new Date(item.signupCloses.replace(' ','T') + '+0100');
              item.serverOpenDate = new Date(item.race_date.replace(' ','T') + '+0100');
              item.signedUp = true;
            });
            this.cdr.detectChanges();
            break;
        }
      });

  }

  getNext() {

    let start = this.pastSessions.data.length;

    this.seasonsService.getMyPastSessions(this.event.event_id, start , 5).subscribe(
      ( response: HttpEvent<any> ) => {
        switch (response.type) {
          case HttpEventType.Response:

            response.body.forEach((item, index) => {
              //item.signupCloseDate = new Date(item.signupCloses.replace(' ','T') + '+0100');
              item.serverOpenDate = new Date(item.race_date.replace(' ','T') + '+0100');
              item.signedUp = true;
              this.pastSessions.data.push(item);
            }, this);
            let all = this.pastSessions.data;
            this.pastSessions = new MatTableDataSource<any>(all);
            break;
        }
      });
  }

  openRaceModal(event, race) {

    this.dialog.open(RaceDetailModalComponent, {
      disableClose: false, data: {event_id: event, race_id: race}, minWidth: window.innerWidth - 400, maxWidth: window.innerWidth - 400
    }).afterClosed().subscribe(result => {

    });
  }

  sendReport(race) {

    this.eventsService.getRaceMinified(race).subscribe(
      ( response: HttpEvent<any> ) => {
        switch (response.type) {
          case HttpEventType.Response:
            this.dialog.open(ReportIncidentComponent, {
              data: {driver: this.auth.currentUser, race: response.body}
            }).afterClosed().subscribe(resp => {
              if (resp) {
                //console.log(resp);
              }
            });
            break;
        }
      });

  }

}
